module.exports = __webpack_public_path__ + "img/lock-unlocked-02.8114a9e8.svg";